import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { RentComponent } from './rent.component';
import { HomeComponent } from '../home/home.component';
import { RentBookingComponent } from './components/rent-booking/rent-booking.component';
import { RentCarDetailsComponent } from './components/rent-car-details/rent-car-details.component';
import { RentSearchComponent } from './components/rent-search/rent-search.component';

const routes: Routes = [
  {
    path: '', component: RentComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'search', component: RentSearchComponent  },
      { path: 'details', component: RentCarDetailsComponent },
      { path: 'booking', canActivate: [AuthGuard], component: RentBookingComponent },
      { path: 'booking-validate', canActivate: [AuthGuard], component: RentBookingComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class RentRoutingModule { }
